// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import LanguageSwitcherController from "./language_switcher_controller"
application.register("language-switcher", LanguageSwitcherController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import SyntaxHighlightController from "./syntax_highlight_controller"
application.register("syntax-highlight", SyntaxHighlightController)

import TocController from "./toc_controller"
application.register("toc", TocController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)
